// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {
  Pagination,
  Dialog,
  Button,
  Image,
  Select,
  Option,
} from 'element-ui';
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Option);
Vue.use(Button);
Vue.use(Image);
Vue.use(VueI18n)
Vue.use(Select)
Vue.use(Option)
// import locale from 'element-ui/lib/locale/lang/en'
import translate from 'i18n-jsautotranslate'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/css/reset.css'
import '@/common/css/mixin.css'
import '@/common/css/iconfont.css'
import * as filters from './utils/filter'
import 'animate.css'
import VueI18n from 'vue-i18n'
import { Popup, Cell, CellGroup, Icon } from 'vant';
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
// Vue.use({ locale })

Vue.prototype.$translate = translate;
// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})
// window.onload = function () {
//   let locale = localStorage.getItem("language");
//   setTimeout(() => {
//     translate.setUseVersion2();
//     translate.language.setLocal(locale);
//     translate.execute();
//   }, 1000);
// }
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js